import styled from 'styled-components';
import { colors } from '../colors';

interface inputProps {
	borderColor?: string;
	autoWidth?: boolean;
}

const Select = styled.select<inputProps>`
	display: inline-block;
	width: 100%;
	background: ${colors.White};
	border: 1px solid ${colors.GreyA0};
	border-radius: 1px;
	height: 36px;
	padding: 6px 16px;
	font-size: 14px;
	transition: ease-in all 0.4s;
	box-sizing: border-box;
	color: ${colors.Grey};
	border-color: ${({ borderColor }) => borderColor}!important;
	:focus {
		outline: none;
		border: 1px solid ${colors.BlueDark};
	}
	${({ autoWidth }) =>
		autoWidth &&
		`width:auto !important;
	`}
`;

export default Select;
